import {
    OwaDate,
    owaDate,
    getYear,
    getMonth,
    getDate,
    getHours,
    getMinutes,
    getSeconds,
    getMilliseconds,
} from 'owa-datetime';

/**
 * Creates a new date, based on the given time zone, date and time.
 * The function assumes the face-values of the given date and time
 * are to be taken as-is and does not perform any normalization.
 */
export default function owaDateFromTzDateTimeValues(tz: string, date: OwaDate, time: OwaDate) {
    return owaDate(
        tz,
        getYear(date),
        getMonth(date),
        getDate(date),
        getHours(time),
        getMinutes(time),
        getSeconds(time),
        getMilliseconds(time)
    );
}
